import React, { useState, useEffect } from 'react'
import { DonutChart } from "@carbon/charts-react";
import { Accordion, AccordionItem } from 'carbon-components-react';

import TableToolbarDownload from '../../common/TableToolbarDownload';
import * as DashboardConstants from '../Dashboards/DashboardConstants';
require("../Dashboards/_dashboard-donut-chart.scss");

const DashboardDonutChart = (props) => {
    const defaultDonutChartOptions = {
        "resizable": true,
        "legend": {
          "alignment": "bottom",
          "enabled": true
        },
        "data": {
          "loading": false
        },
        "donut": {
          "center": {
            "label": "All"
          },
          "alignment": "center"
        },
        "pie": {
          "alignment": "center",
          "labels": {
            "enabled": false
          }
        },
        "color": {
          "pairing": {
            "option": 2
          }
        },
        "height": "300px"
      };

    const donutGraphHeaders = [
        {
            key: 'group',
            header: DashboardConstants.Group
        },
        {
            key: 'value',
            header: DashboardConstants.Value
        }
    ];

    const [graphOptions, setGraphOptions] = useState(defaultDonutChartOptions);
    const [graphData, setGraphData] = useState([]);

    const prepareDonutChartInput = () => {
        let options = graphOptions;
        let scale = {}; let data = [];
        let colors = ['#8A3FFC', '#08BDBA', '#BAE6FF'];
        data = props.donutChartData ? props.donutChartData : [];
        for (let i = 0; i < data.length; i++) {
            scale[data[i].group] = colors[i];
        }
        options.color.scale = scale;
        options.data.loading = props.loading;
        setGraphOptions(options);
        setGraphData(data);
    };

    useEffect(() => {
        prepareDonutChartInput();
    }, [props.loading]);

    return (
        <div className="dashboard-donut-chart-container">
            <div className="graph-title carbon-display-Regular-20">
                <div>{props.title}</div>
                {/* <div className="download-button">
                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={graphData} headers={donutGraphHeaders} title={props.title} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                </div> */}
            </div>
            {!graphOptions.data.loading && !graphData.length ?
                <div>{DashboardConstants.NoDataAvailable}</div>
                :
                <div className="dashboard-donut-chart">
                    <DonutChart
                        data={graphData}
                        options={graphOptions}>
                    </DonutChart>
                </div>
            }
        </div>
    );
};

export default DashboardDonutChart;
